module.exports = __webpack_public_path__ + "img/log-out.fd7102fe.svg";